<script lang="ts">
	import { page } from '$app/stores';
	import ChartRangeOptionItem from '$lib/portfolio/ChartRangeOptionItem.svelte';
	import ChartSelectorItem from './ChartSelectorItem.svelte';
	import FundingRateIntervalSelector from './FundingRateChart/FundingRateIntervalSelector.svelte';
	import FundingRateRangeSelector from './FundingRateChart/FundingRateRangeSelector.svelte';
	import { chartSelected } from './store';
	export let showBorder = true;
</script>

<div class="flex justify-start w-full items-center gap-4 px-4" class:border-style={showBorder}>
	{#if $page.url.pathname != '/strategies'}
		<ChartSelectorItem heading="Price Chart" selection="TradingView" />
		<ChartSelectorItem heading="Funding Rate" selection="FundingRate" />
		{#if $chartSelected === 'TradingView'}
			<img
				src="/integrations/powered-by-pyth.svg"
				alt="Powered by Pyth"
				loading="lazy"
				class="h-3 ml-auto"
			/>
		{/if}
	{/if}
	{#if $chartSelected == 'FundingRate' || $page.url.pathname == '/strategies'}
		<FundingRateIntervalSelector />
		<FundingRateRangeSelector />
	{/if}
</div>

<style>
	.border-style {
		@apply border-b border-fx-grey-500 border-r py-2;
	}
</style>
